export default "<div class=\"w3-content\">\n    <div class=\"w3-row-padding\"\n         data-dojo-attach-point=\"tableContainer\">\n\n    </div>\n</div>"